import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async getBuildings(meetingId) {
    try {
      const { data } = await api.get(url(ENDPOINTS.buildings, { meetingId }), {
        params: { owners: 1 },
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getParticipation(meetingId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.participation, { meetingId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
